import type { MapView } from '../types/gis';

export interface MapLibreFlyArgs {
  center: [number, number];
  zoom: number;
  bearing?: number;
}

/** Convert a backend-supplied view_hint into args MapLibre's flyTo / fitBounds
 *  understand. Returns null for null/undefined. */
export function applyViewHint(view: MapView | null | undefined): MapLibreFlyArgs | null {
  if (!view) return null;
  return {
    center: view.center,
    zoom: view.zoom,
    bearing: view.bearing ?? 0,
  };
}
